import { FilterToTypes } from '../../constants/filter/filter_to_types';
import { FilterTypeDefaultValues } from '../../constants/filter/filter_type_default_values';

function getDefaultValueForFilter( filterName ) {
    return FilterTypeDefaultValues[FilterToTypes[filterName]];
}

export { getDefaultValueForFilter };